export default function Footer() {

  return (
    <div className="footer">
      Yes, we know he's "Frankenstein's monster" and not Frankenstein. And Christopher Marlowe probably wrote most of Shakespeare's work. So what? Let people have nice things.
    </div>
  )
}